import colorHelper from './color';

const init = () => {
  initGt();
  colorHelper.importFromGTtoConstants();
};

const initGt = () => {
  // window.GT = JSON.parse(document.querySelector('script[type="application/json"][ganttpro-application-json-selector="gt"]').textContent);
  // window.user = window.GT.user;

  if (document.querySelector('script[type="application/json"][ganttpro-application-json-selector="gt"]')) {
    window.GT = JSON.parse(document.querySelector('script[type="application/json"][ganttpro-application-json-selector="gt"]').textContent);
    window.user = window.GT.user;
    window.sharedData = window.GT.sharedData;
    // window.gantt = {
    //   attachEvent: () => {},
    //   setBlockingCollaborationByPopup: () => {},
    // };
  } else {
    // window.GT = {};
    // window.user = {};
  }
};

init();
export default true;
